import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField, Alert
} from "@mui/material";

const OptionTypeModal = ({ open, onAdd, editingType, onSave, onCloseModal }) => {
    const [value, setValue] = useState('');

    React.useEffect(() => {
        setValue(editingType || '');
    }, [editingType]);

    const handleAddOrSave = () => {
        const typeName = value.trim();
        if (!typeName || typeName.length > 30) return;

        if (editingType) {
            onSave(editingType, typeName);
        } else {
            onAdd(typeName);
        }

        setValue('');
        onCloseModal();
    };

    const isOverLimit = value.length > 30;

    return (
        <Dialog open={open} onClose={onCloseModal} fullWidth maxWidth="sm">
            <DialogTitle>{editingType ? 'オプション編集' : 'オプション追加'}</DialogTitle>

            <DialogContent>
                <Alert severity="info" sx={{ mt: 2, mb: 1 }}>
                    内容はまだ保存されていません。ページ下部の「更新する」で保存されます。
                </Alert>
                <TextField
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    placeholder="例：色、サイズ"
                    error={isOverLimit}
                    helperText={isOverLimit ? 'オプション名は30文字以内で入力してください' : ''}
                    inputProps={{ maxLength: 30 }}
                />
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onCloseModal}>
                    キャンセル
                </Button>

                <Button
                    variant="contained"
                    onClick={handleAddOrSave}
                    disabled={!value.trim() || isOverLimit}
                >
                    {editingType ? '変更' : '追加'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OptionTypeModal;
